import classNames from 'classnames/bind';
import styles from './gameNotice.module.scss';

const cx = classNames.bind(styles);

const GameNotice = () => {
  return (
    <p className={cx('noticeText')}>
      전략게임 응시 가이드에서는 학습에 의한 점수 향상이 아닌 전략게임의 응시 방법을 습득하여 친숙도를 향상시키는데
      목적을 두고 있어요!
      <br />
      게임 방법에 익숙하지 않거나 목표를 잘못 이해하여 역량을 제대로 드러내지 못하는 일이 없도록 본인 역량을 최대로
      발휘할 수 있는 상태인지
      <br />
      확인 및 가이드 해드려요!
    </p>
  );
};

export default GameNotice;
